"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = matcher;

var _extendOwn = _interopRequireDefault(require("./extendOwn.js"));

var _isMatch = _interopRequireDefault(require("./isMatch.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Returns a predicate for checking whether an object has a given set of
// `key:value` pairs.
function matcher(attrs) {
  attrs = (0, _extendOwn.default)({}, attrs);
  return function (obj) {
    return (0, _isMatch.default)(obj, attrs);
  };
}